'use client';

import React from 'react';

type CardStepProps = {
    icon: any;
    title: string;
    text: string;
    className?: string;
    button?: string;
    onClick?: () => void;
};

const CardStep: React.FC<CardStepProps> = ({ icon, title, text, button, onClick, className }) => {

    return (
        <div className={`${className} bg-grayLight py-10 px-5 md:px-14 rounded-cornerMob w-full`}>
            <div className='flex justify-between flex-row-reverse md:flex-col mb-3'>
                <div className='w-2/12 flex justify-end md:justify-normal md:mb-3'>{icon}</div> <h2 className='w-10/12 flex items-end'>{title}</h2>
            </div>
            <div>
                {text}
            </div>
            {
                button
                    ? <button
                        className='buttonH2 mt-5'
                        onClick={onClick}
                    >{button}</button>
                    : null
            }
        </div>
    );
};

export default CardStep;
